import React from 'react';
import classnames from 'classnames';
import './styles.scss';

interface LargeTickProps {
  active?: boolean;
}

const LargeTick: React.FC<LargeTickProps> = ({ active = false }) => {
  return (
    <svg
      className={classnames('icon--large-tick', {
        active: active,
      })}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 13"
      fill="none"
    >
      <path d="M1 6L6 11L16 1" strokeWidth="2" />
    </svg>
  );
};

export default LargeTick;
